import * as React from "react";

let isHydrating = true;

export function useIsHydrated() {
  const [isHydrated, setIsHydrated] = React.useState(() => !isHydrating);
  // eslint-disable-next-line replo/no-use-effect -- Legacy effect - may or may not be necessary
  React.useEffect(() => {
    isHydrating = false;
    setIsHydrated(true);
  }, []);
  return isHydrated;
}
